import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {},
  error: null,
};

const { Types, Creators } = createActions(
  {
    getData: ['range'],
    getDataRequest: [],
    getDataSuccess: ['data'],
    getDataFailure: ['error'],
  },
  { prefix: 'cb/dashboards/' },
);

export { Types as types, Creators as actions };

export const request = state => {
  return {
    ...state,
    fetching: true,
  };
};

export const success = (_, action) => {
  const { data } = action;
  return {
    ...INITIAL_STATE,
    fetched: true,
    data,
  };
};

export const failure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetching: false,
    error,
  };
};

export const HANDLERS = {
  [Types.GET_DATA_REQUEST]: request,
  [Types.GET_DATA_SUCCESS]: success,
  [Types.GET_DATA_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
